import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ComponentBase, DialogData } from '@definitiv-packages/angular-dba-library';
import { ProjectLanguage } from '../../types/ProjectLanguage';
import { DebitorModelView } from '../../types/DebitorModel';
import { StandortModel, StandortModelView } from '../../types/StandortModel';
import { SysLandModel } from '../../types/SysLandModel';
import { StandortService } from '../../services/Models/StandortModel.service';
import { DebitorViewService } from '../../services/Views/DebitorModelView.service';
import { SysLandService } from '../../services/Models/SysLandModel.service';


@Component({
  selector: 'app-create-standort',
  templateUrl: './create-standort.component.html',
  styleUrls: ['./create-standort.component.scss'],
  standalone: false
})
export class CreateStandortComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public Title: string = "";
  public standort: StandortModel | null = null;

  public debitorList: DebitorModelView[] = [];
  public landList: SysLandModel[] = [];

  private BezeichnungControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(100)]);
  public StrasseControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  public PLZControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(10)]);
  public OrtControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  private LandControl: FormControl<SysLandModel | null> = new FormControl<SysLandModel | null>(null);
  private DebitorControl: FormControl<DebitorModelView | null> = new FormControl<DebitorModelView | null>(null,[Validators.required]);
  private WartungAbControl: FormControl<Date | null> = new FormControl<Date | null>(null);
  private WartungIntervallControl: FormControl<number | null> = new FormControl<number | null>(null, Validators.max(36));

  public FormGroup = new UntypedFormGroup({
    bezeichnungControl: this.BezeichnungControl,
    strasseControl: this.StrasseControl,
    plzControl: this.PLZControl,
    ortControl: this.OrtControl,
    landControl: this.LandControl,
    debitorControl: this.DebitorControl,
    wartungabControl: this.WartungAbControl,
    wartungintervallControl: this.WartungIntervallControl
  });
  //#endregion

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData<StandortModelView>,
    public dialogRef: MatDialogRef<CreateStandortComponent>,
    public standortService: StandortService,
    public debitorService: DebitorViewService,
    public syslandService: SysLandService
  ) { super(); }

  public async ngOnInit() {
    this.loading = true;

    this.debitorList = await this.debitorService.getList();
    this.landList = await this.syslandService.getList();

    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.Standorterstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.Standortbearbeiten);
    }

    if (!this.data.data?.StandortID && this.data.data?.DebitorID) {
        this.debitorList = this.debitorList.filter(x=>x.DebitorID == this.data.data?.DebitorID);
    }
    if (this.data.data?.StandortID) {

        this.standort = await this.standortService.get(this.data.data.StandortID);
        this.BezeichnungControl.setValue(this.standort.Bezeichnung);

        this.StrasseControl.setValue(this.standort.Strasse);
        this.PLZControl.setValue(this.standort.PLZ);
        this.OrtControl.setValue(this.standort.Ort);

        if (this.standort.LandID) this.LandControl.setValue(this.landList.find(x => x.LandID == this.standort?.LandID)!);

        if (this.standort.DebitorID) this.DebitorControl.setValue(this.debitorList.find(x => x.DebitorID == this.standort?.DebitorID)!);
    }
    else {

        this.standort = {} as StandortModelView;
    }
    this.loading = false;
  }

  public async Save(): Promise<void> {
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (this.FormGroup.valid) {

      this.loading = true;
      this.standort = new StandortModel();

      if (this.data.mode == 'edit' && this.data.data)
        this.standort.StandortID = this.data.data?.StandortID;

      this.standort.Bezeichnung = this.BezeichnungControl.value!;

      this.standort.Strasse = this.StrasseControl.value ?? '';
      this.standort.PLZ = this.PLZControl.value ?? '';
      this.standort.Ort = this.OrtControl.value ?? '';


      if (this.LandControl.value)
        this.standort.LandID = this.LandControl.value?.LandID;
      if (this.DebitorControl.value)
        this.standort.DebitorID = this.DebitorControl.value?.DebitorID;

      if (this.standort.StandortID > 0)       //Update
        var Item = await this.standortService.put(this.standort.StandortID, this.standort)
      else                                  // Insert
        var Item = await this.standortService.post(this.standort)

      this.loading = false;
      this.dialogRef.close(Item);
    }
  }

  openMaps() {
    var adress = this.StrasseControl.value + ", " + this.PLZControl.value + " " + this.OrtControl.value;
    const url = "https://www.google.com/maps?q=" + adress + '&z=16';
    window.open(url, '_blank');
  }

  public Abbrechen() {
    this.dialogRef.close();
  }
}
